// extracted by mini-css-extract-plugin
export var attachment = "_s4-a";
export var emailContainer = "_s4-4";
export var emailContentPaddedContainer = "_s4-b";
export var emailHeader = "_s4-6";
export var emailIframe = "_s4-3";
export var emailInfoIcon = "_s4-9";
export var emailShortenedSummary = "_s4-e";
export var infoDropdown = "_s4-0";
export var infoRowBoundedContent = "_s4-d";
export var internal = "_s4-5";
export var merchant = "_s4-8";
export var messageInputContainer = "_s4-h";
export var normal = "_s4-7";
export var replyCard = "_s4-f";
export var subtleButton = "_s4-1";
export var subtleButtonIconContainer = "_s4-2";
export var toggleViewRepliesButton = "_s4-c";
export var wrappingText = "_s4-g";